import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const collage = {
  createImageCollage: lazyModuleMethod(
    () => import('./createImageCollage'),
    'default'
  ),
  fetchImageCollageMeta: lazyModuleMethod(
    () => import('./fetchImageCollageMeta'),
    'default'
  ),
}
